import { render, staticRenderFns } from "./send.vue?vue&type=template&id=3d2b601c"
import script from "./send.vue?vue&type=script&lang=js"
export * from "./send.vue?vue&type=script&lang=js"
import style0 from "./send.vue?vue&type=style&index=0&id=3d2b601c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2b601c')) {
      api.createRecord('3d2b601c', component.options)
    } else {
      api.reload('3d2b601c', component.options)
    }
    module.hot.accept("./send.vue?vue&type=template&id=3d2b601c", function () {
      api.rerender('3d2b601c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/work/send.vue"
export default component.exports